import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedCrossedOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="m4.536 1.566-.72-.72C4.763.572 6.124.5 8 .5c3.442 0 5.152.242 5.748 1.534a9 9 0 0 0-1.574-.377C11.018 1.479 9.62 1.43 8 1.43c-1.302 0-2.46.031-3.464.136"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.462 3.452C.655 4.208.238 5.822.642 9.165 1.31 14.708 2.23 15.5 8 15.5c2.8 0 4.457-.186 5.499-1.011L14.51 15.5l.99-.995-14.005-14-.99.99zM3.57 4.56c-.518.13-.838.29-1.043.454-.457.364-.835 1.171-.496 3.983.166 1.373.337 2.352.565 3.074.223.702.47 1.06.725 1.28.26.223.668.425 1.433.56.78.138 1.816.19 3.246.19s2.466-.052 3.246-.19c.606-.107.989-.256 1.25-.425L8.334 9.323v1.21H3.667v-1.4h4.477L6.71 7.7H3.334V6.3H5.31z"
                        fill="currentColor"
                    />
                    <path
                        d="m5.844 2.873 1.362 1.362q.38-.005.794-.005c1.598 0 2.815.05 3.747.194.94.145 1.442.364 1.726.59.457.364.835 1.171.496 3.983-.081.67-.163 1.247-.253 1.746l1.182 1.18c.187-.754.329-1.663.46-2.758C16.029 3.622 14.44 2.83 8 2.83q-1.184-.002-2.156.043"
                        fill="currentColor"
                    />
                    <path d="m9.272 6.3 1.4 1.4h1.995V6.3z" fill="currentColor" />
                </g>
            </g>
        </svg>
    )
);
CardLinesStackedCrossedOutlinedSize16Glyph.displayName = 'CardLinesStackedCrossedOutlinedSize16Glyph';
